/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorSymptomDto } from '../../models/create-vendor-symptom-dto';
import { VendorSymptomDto } from '../../models/vendor-symptom-dto';

export interface AsControllerCreateVendorSymptom$Params {
  clientWorkspaceId: string;
      body: CreateVendorSymptomDto
}

export function asControllerCreateVendorSymptom(http: HttpClient, rootUrl: string, params: AsControllerCreateVendorSymptom$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorSymptomDto>> {
  const rb = new RequestBuilder(rootUrl, asControllerCreateVendorSymptom.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorSymptomDto>;
    })
  );
}

asControllerCreateVendorSymptom.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms';
